import parse from 'html-react-parser'
import { useBranding } from 'utils/useBranding'

interface PreviewIntroPanelProps {
  introTitle?: string
  introText?: string
}

const PreviewIntroPanel = ({
  introTitle,
  introText,
}: PreviewIntroPanelProps) => {
  const { branding } = useBranding()

  return (
    <section
      className={`bg-white px-9 py-20 lg:py-32 lg:px-24 section-border-grey`}
    >
      <div className="container mx-auto xl:px-12">
        <h2
          className={`text-center sm:text-left`}
          style={{
            color: branding.stylingPrimary || '#3b82f6',
          }}
        >
          {introTitle || 'Sample Introduction Title'}
        </h2>
        <hr
          className="hr rounded-cap"
          style={{
            backgroundColor: branding.stylingSecondary || '#10b981',
          }}
        ></hr>
        <p
          className={`xl:max-w-[80%] text-212121 text-center sm:text-left font-medium`}
        >
          {introText
            ? parse(introText)
            : 'This is a sample introduction text that describes what your introduction section will contain when it goes live. You can use HTML formatting for bold text, italics, and other styling.'}
        </p>
      </div>
    </section>
  )
}

export default PreviewIntroPanel
